import Compile from "./Compile.js";
// import store from "@/store";
let store = {};
const sha256 = require("js-sha256");
const Base64 = require("js-base64").Base64;
// 生成随机字符串
function generateRandomAlphaNum(len) {
    var rdmString = ''
    for (
        ;
        rdmString.length < len;
        rdmString += Math.random()
            .toString(36)
            .substr(2)
    );
    return rdmString.substr(0, len)
}
let clientToken;
// token接口加密处理
export const tokenRequsetProcess = function (params) {
    clientToken = params.client_token;
    params.nonce = generateRandomAlphaNum(32);
    params.timestamp = +new Date();
    params.sign_hash = Base64.encode(sha256(JSON.stringify(params)));
    let p = JSON.stringify(params);
    // 加解密需要传入参数为字符串格式，token走rsa加密，其余走des加密
    p = Compile.rsaEn(p);
    return p;
};
// token接口响应处理
export const tokenResponseProcess = function (response) {
    // 响应rsa解密
    let data = JSON.parse(Compile.decryptByDESModeEBC(response, clientToken));
    let workKey = Base64.decode(Compile.rsaDe(data.work_key));
    return workKey;
};

// 接口加密处理
export const requsetProcess = function (params) {
    params.nonce = generateRandomAlphaNum(32);
    params.timestamp = +new Date();
    params.sign_hash = Base64.encode(sha256(JSON.stringify(params)));
    let p = JSON.stringify(params);
    // 加解密需要传入参数为字符串格式，token走rsa加密，其余走des加密
    // console.log('232',localStorage.workKey)
    p = Compile.encryptByDES(p, localStorage.workKey);
    return p;
};
// 接口响应解密处理
export const responseProcess = function (response) {
    // 非token接口走此解密
    console.log('234',localStorage.workKey)
    let data = JSON.parse(Compile.decryptByDESModeEBC(response, localStorage.workKey));
    // console.log('adta',data)
    
    return data;
};
